import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from '../models/geo-db/country';
import { BaseResponseGeoDb } from '../models/geo-db/base-response';
import { City } from '../models/geo-db/city';

@Injectable({ providedIn: 'root' })
export class GeoDbProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = 'https://wft-geo-db.p.rapidapi.com/v1/geo';

  searchByCity(city: string, namePrefix?: string): Observable<BaseResponseGeoDb<City[]>> {
    let url = `${this.baseUrl}/cities?countryIds=${city}`;
    if (namePrefix) {
      url += `&namePrefix=${encodeURIComponent(namePrefix)}`;
    }

    return this.httpClient.get<BaseResponseGeoDb<City[]>>(url, {
      headers: {
        'x-rapidapi-host': 'wft-geo-db.p.rapidapi.com',
        'x-rapidapi-key': 'e5d9679d03msh8f004f2d82e9435p171f8fjsn768474360e61',
      },
    });
  }

  searchCountries(namePrefix: string): Observable<BaseResponseGeoDb<Country[]>> {
    const url = `${this.baseUrl}/countries?namePrefix=${encodeURIComponent(namePrefix)}`;

    return this.httpClient.get<BaseResponseGeoDb<Country[]>>(url, {
      headers: {
        'x-rapidapi-host': 'wft-geo-db.p.rapidapi.com',
        'x-rapidapi-key': 'e5d9679d03msh8f004f2d82e9435p171f8fjsn768474360e61',
      },
    });
  }
}
